import React from "react";
import { Message, AuthContext, ViewContext } from 'components/lib';
import { useContext } from 'react';

// import messages from 'views/account/billing/messages.json';
// only triggers for external payments
const Messages = require('./billing/messages.json');


export function PaymentPending() {
    const context = useContext(AuthContext);
    const viewContext = useContext(ViewContext);
    const user = context?.user;

    if (user?.subscription === 'expiring_soon') {
        if ((0 < user?.days_due) && (user?.days_due <= 15)) {
            Messages.expiring_soon.text = viewContext.t('Components.PaymentPending.message.willExpire', { days: user?.days_due});
        } else if (user?.days_due === 0) {
            Messages.expiring_soon.text = viewContext.t('Components.PaymentPending.message.expireToday');
        }
    } else if (user?.subscription === 'disabled' && -1 > user?.days_due && user?.days_due >= -30) {
        Messages.expired.text = viewContext.t('Components.PaymentPending.message.hasExpired', { days: Math.abs(user?.days_due)});
        
    }

    return (
        <div>
            <Message {
                ...Messages[user?.subscription]
            }
            />
        </div>
    )

}
